/**
 * Switch — DS Atom
 * ON color = --hrl-action (#16a34a)
 */

import styles from './Switch.module.css';

interface SwitchProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
}

export function Switch({ label, checked = false, onChange, disabled = false, id, className = '' }: SwitchProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={`${styles.track} ${checked ? styles.trackOn : ''} ${disabled ? styles.disabled : ''}`}
        onClick={() => !disabled && onChange?.(!checked)}
        role="switch"
        aria-checked={checked}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={e => e.key === ' ' && !disabled && onChange?.(!checked)}
      >
        <div className={`${styles.thumb} ${checked ? styles.thumbOn : ''}`} />
      </div>
      {label && (
        <label className={styles.label} htmlFor={id}>{label}</label>
      )}
    </div>
  );
}
